import React from 'react'
import { Box, Grid, Typography } from "@mui/material";
import { Link } from "../../Link";
import { TagType } from "../../../types";
import { useStyles } from "./Tags.styles";

interface TagsProps {
	tags: TagType[]
	selectedTag?: TagType
}

export function Tags({ tags, selectedTag }: TagsProps) {
	const { classes, cx } = useStyles()

	return (
		<section className={classes.root}>
			<Box className={classes.container}>
				<Grid container spacing={2}>
					{tags.map((tag) => (
						<Grid item key={tag.id}>
							<Link to={`/blog/tag/${tag?.name || 'inmobiliario'}`}>
								<div className={cx(classes.tag, { [classes.active]: selectedTag?.id === tag?.id })}>
									<Typography>
										{tag.name}
									</Typography>
								</div>
							</Link>
						</Grid>
					))}

				</Grid>
			</Box>
		</section>
	)
}